import React from 'react';

// UIKit Components
import { Box, FlexBox, FlexBoxProps } from '@spazious/react-components';

export type CenteredContainerProps = FlexBoxProps & {
  children?: React.ReactNode;
  spacing?: string | number;
};

export const CenteredContainer = React.forwardRef(
  (
    { children, spacing, padding = spacing, ...restProps }: CenteredContainerProps,
    ref: React.ForwardedRef<HTMLElement>
  ) => {
    return (
      <FlexBox ref={ref} direction="row" justifyContent="center" {...restProps}>
        <Box flex="1" maxWidth="var(--max-container-width)" padding={padding}>
          {children}
        </Box>
      </FlexBox>
    );
  }
);

export default CenteredContainer;
